import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Tags } from '@tryghost/helpers-gatsby'
import { readingTime as readingTimeHelper } from '@tryghost/helpers'

const RelatedPosts = ({ post }) => {
    const url = `https://www.vantagefit.io/casestudy/${post.slug}/`
    const readingTime = readingTimeHelper(post)

    return (
        <article className=" col-12 col-sm-4 col-md-4 col-lg-4 item d-left">
            <div className="bg-white brad-16 p-4 shadowN box-shadow">
                <div className="overflow brad-16">
                    <a href={ url } className="featured-image" title={ post.title }>
                        <img className="img-responsive ease lozad" src={ post.feature_image } alt={ post.title} loading="lazy" width="340" height="208" style={{height: "100%"}}/>
                    </a>
                </div>
                <div className="guideDetailsLink pb-0">
                    <div className="post_titel casestudyRecent">
                        <a href={ url } title={ post.title }>{ post.title }</a>
                    </div>
                </div>
                <div className="blog_excerpt">
                    { post.excerpt }
                </div>
                <div className="postReadMore"><a href={ url } title={ post.title } className=" links">
                    Read More <span className="campaignSprite"></span>
                </a></div>
            </div>
        </article>
    )
}

RelatedPosts.propTypes = {
    post: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        feature_image: PropTypes.string,
        featured: PropTypes.bool,
        tags: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
            })
        ),
        excerpt: PropTypes.string.isRequired,
        primary_author: PropTypes.shape({
            name: PropTypes.string,
            profile_image: PropTypes.string,
        }),
    }).isRequired,
}

export default RelatedPosts
